export const extensionFields = [
  {
    category: "projectInformation",
    children: "Project Information",
    inputType: "h4",
    inForm: true,
    wrapperClass: "col-md-12",
    className: "heading2",
  },
  {
    category: "projectInformation",
    label: "Project Title",
    placeholder: "Select Project Title",
    name: "nocAppId",
    id: "nocAppId",
    inputType: "async-dropdown",
    url: "/NocApplication/GetAllNOCProject",
    searchAttrib: "Search.value",
    labelAttribute: "projectTitle",
    valueAttribute: "id",
    onChangeMethod: "dropdown-in-table",
    inForm: true,
    isEnum: true,
    isMulti: false,
    validation: {
      required: true,
    },

    wrapperClass: "col-md-12",
  },
  {
    category: "planUnderProject",
    children: "Plan Under Which Project Falls (If Applicable)",
    inputType: "h4",
    inForm: true,
    wrapperClass: "col-md-12",
    className: "heading2",
  },
  {
    category: "planUnderProject",
    children: "Please Tick relevant boxes, Multiple selection possible",
    inputType: "p",
    inForm: true,
    wrapperClass: "col-md-12",
  },
  {
    category: "planUnderProject",
    text: "Pakistan Humanitarian Response Plan (PHRP)",
    name: "phrp",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "planUnderProject",
    text: "Non-Pakistan Humanitarian Response Plan (Non-PHRP)",
    name: "nonPhrp",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "planUnderProject",
    text: "Flood Emergency Response Plan (FERP)",
    name: "ferp",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "planUnderProject",
    text: "Non-Flood Emergency Response Plan (Non-FERP)",
    name: "nonFerp",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "planUnderProject",
    text: "Other",
    name: "otherPlan",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "planUnderProject",
    name: "otherPlanSpecify",
    placeholder: "Specify Other Here",
    inForm: true,
    wrapperClass: "col-md-6 mt-2",
  },
  {
    category: "clusterUnderProject",
    children: "Cluster  Under Which  Project Falls",
    inputType: "h4",
    inForm: true,
    wrapperClass: "col-md-12 mt-4",
    className: "heading2",
  },
  {
    category: "clusterUnderProject",
    children:
      "Please tick (√) relevant boxes, Multiple selection possible. Vetting from relevant cluster head will  be required",
    inputType: "p",
    inForm: true,
    wrapperClass: "col-md-12",
  },
  {
    category: "clusterUnderProject",
    text: "Agriculture",
    name: "agriculture",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "clusterUnderProject",
    text: "Camp Coordination",
    name: "campCoordination",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "clusterUnderProject",
    text: "Child Protection (Sub-cluster)",
    name: "childProtection",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "clusterUnderProject",
    text: "Community Restoration",
    name: "communityRestoration",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "clusterUnderProject",
    text: "Education",
    name: "education",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "clusterUnderProject",
    text: "Food Security",
    name: "foodSecurity",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "clusterUnderProject",
    text: "Gender",
    name: "gender",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "clusterUnderProject",
    text: "Health",
    name: "health",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "clusterUnderProject",
    text: "Nutrition",
    name: "nutrition",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "clusterUnderProject",
    text: "Protection",
    name: "protection",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },

  {
    category: "clusterUnderProject",
    text: "Rule of Law & Justice",
    name: "ruleOfLawAndJustice",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "clusterUnderProject",
    text: "Skill Development",
    name: "skillDevelopment",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "clusterUnderProject",
    text: "Shelter and Non-Food Items",
    name: "shelterAndNonFoodItems",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "clusterUnderProject",
    text: "DRR / CCA",
    name: "drrCca",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "clusterUnderProject",
    text: "Wash",
    name: "wash",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "clusterUnderProject",
    text: "Other",
    name: "other",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "geographicLocation",
    children: "Geographic Location & Beneficiaries",
    inputType: "h4",
    inForm: true,
    wrapperClass: "col-md-12",
    className: "heading2",
  },
  {
    category: "geographicLocation",
    children: "Please indicate the geographic location of the project",
    inputType: "p",
    inForm: true,
    wrapperClass: "col-md-12",
  },
  {
    category: "geographicLocation",
    label: "",
    name: "geographicLocations",
    inputType: "tableInput",
    inForm: true,
    className: "w-100 table-overflow",
    wrapperClass: "col-12",
    header: [
      {
        label: "District",
        placeholder: "Select District",
        name: "districtId",
        id: "districtId",
        inputType: "async-dropdown",
        url: "/District",
        searchAttrib: "Search.value",
        labelAttribute: "name",
        valueAttribute: "id",
        onChangeMethod: "dropdown-in-table",
        inForm: true,
        isMulti: false,
        className: "px-2",
      },
      {
        label: "Tehsil",
        placeholder: "Select Tehsil",
        name: "tehsil",
        id: "tehsil",
        inputType: "text",
        // url: "/ERActivity/GetActivities",
        searchAttrib: "Search.value",
        labelAttribute: "name",
        valueAttribute: "id",
        onChangeMethod: "text-in-table",
        inForm: true,
        className: "px-2",
      },
      {
        label: "Union Council",
        placeholder: "Enter Union Council",
        name: "unionCouncil",
        inForm: true,
        onChangeMethod: "text-in-table",
        wrapperClass: "col-md-12",
      },
      {
        label: "Village",
        placeholder: "Enter Village",
        name: "village",
        onChangeMethod: "text-in-table",
        inForm: true,
      },
    ],
  },

  {
    category: "thematicArea",
    children: "Thematic Areas Under  Which the  Project Falls",
    inputType: "h4",
    inForm: true,
    wrapperClass: "col-md-12",
    className: "heading2",
  },
  {
    category: "thematicArea",
    children: "Please tick (√) relevant boxes",
    inputType: "p",
    inForm: true,
    wrapperClass: "col-md-12",
  },
  {
    category: "thematicArea",
    text: "Legislation, Policy, Institutional Mandate & Institutional Development",
    name: "legislationDevelopment",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "thematicArea",
    text: "Hazard, Vulnerability and Risk Assessment",
    name: "hazardVulnerabilityRiskAssessment",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "thematicArea",
    text: "Public Awareness, Education and Training",
    name: "publicAwarenessEducationTraining",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "thematicArea",
    text: "Community Resilience through CBDRM",
    name: "communityResilienceThroughCbdrm",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "thematicArea",
    text: "Mainstreaming Disaster Risk Reduction into Development Planning",
    name: "mainstreamingPlanning",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "thematicArea",
    text: "Early Warning System",
    name: "earlyWarningSystem",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "thematicArea",
    text: "Preparedness and Response Planning",
    name: "preparednessAndResponsePlanning",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "thematicArea",
    text: "Post Disaster Recovery Planning",
    name: "postDisasterRecoveryPlanning",
    inputType: "checkbox",
    inForm: true,
    wrapperClass: "col-md-6",
  },

  {
    category: "directBeneficiaries",
    children: "Estimated  Number of  Direct  Beneficiaries",
    inputType: "h4",
    inForm: true,
    wrapperClass: "col-md-12",
    className: "heading2",
  },
  {
    category: "directBeneficiaries",
    children:
      "Please fill in the total number of direct HH/beneficiaries. For More than one  beneficiaries add in separate",
    inputType: "p",
    inForm: true,
    wrapperClass: "col-md-12",
  },
  {
    category: "directBeneficiaries",
    name: "projectBeneficiaries",
    id: "projectBeneficiaries",
    inputType: "tableInput",
    inForm: true,
    className: "w-100 table-overflow",
    wrapperClass: "col-12",
    header: [
      {
        label: "Sector",
        placeholder: "Select Sector",
        name: "clusterId",
        id: "clusterId",
        inputType: "async-dropdown",
        // url: "/Cluster",
        // searchAttrib: "Search.value",
        labelAttribute: "name",
        valueAttribute: "id",
        onChangeMethod: "dropdown-in-table",
        className: "px-2",
        isEnum: true,
        inForm: true,
        isMulti: false,
      },
      {
        label: "District",
        placeholder: "Select District",
        name: "districtId",
        id: "districtId",
        inputType: "async-dropdown",
        // url: "/District",
        // searchAttrib: "Search.value",
        labelAttribute: "name",
        valueAttribute: "id",
        onChangeMethod: "dropdown-in-table",
        inForm: true,
        isMulti: false,
        className: "px-2",
      },

      {
        label: "Households",
        placeholder: "Enter Households",
        name: "houseHolds",
        onChangeMethod: "text-in-table",
        inForm: true,
      },
      {
        label: "No of Male",
        placeholder: "Enter No of Male",
        name: "noOfMales",
        onChangeMethod: "text-in-table",
        inForm: true,
      },
      {
        label: "No of Female",
        placeholder: "Enter No of Female",
        name: "noOfFemales",
        onChangeMethod: "text-in-table",
        inForm: true,
      },
    ],
  },
  {
    category: "proposedTimeFrame",
    children: "Proposed Timeframe For Project",
    inputType: "h4",
    inForm: true,
    wrapperClass: "col-md-12",
    className: "heading2",
  },
  {
    category: "proposedTimeFrame",
    children: "Please indicate the duration of the project:  ",
    inputType: "p",
    inForm: true,
    wrapperClass: "col-md-12",
  },
  {
    category: "proposedTimeFrame",
    label: "Start",
    placeholder: "Choose Start Date",
    name: "projectStartDate",
    inForm: true,
    wrapperClass: "col-md-4",
    inputType: "date",
  },
  {
    category: "proposedTimeFrame",
    label: "End",
    placeholder: "Choose End Date",
    name: "projectEndDate",
    inForm: true,
    wrapperClass: "col-md-4",
    inputType: "date",
  },

  {
    category: "agreementtimeframe",
    children: "Proposed Timeframe For Agreement",
    inputType: "h4",
    inForm: true,
    wrapperClass: "col-md-12",
    className: "heading2",
  },
  {
    category: "agreementtimeframe",
    children: "Please indicate the duration of the agreement:  ",
    inputType: "p",
    inForm: true,
    wrapperClass: "col-md-12",
  },
  {
    category: "agreementtimeframe",
    label: "Start",
    placeholder: "Choose AgreementStart Date",
    name: "agreementStartDate",
    inForm: true,
    wrapperClass: "col-md-4",
    inputType: "date",
  },
  {
    category: "agreementtimeframe",
    label: "End",
    placeholder: "Choose Agreement End Date",
    name: "agreementEndDate",
    inForm: true,
    wrapperClass: "col-md-4",
    inputType: "date",
  },
  {
    category: "agreementtimeframe",
    label: "Donor Organization",
    placeholder: "Name of Donor Organization",
    name: "donorOrganization",
    inForm: true,
    isEnum: true,
    wrapperClass: "col-md-4",
    validation: {
      required: true,
    },
  },
  {
    category: "summaryOfProjectCost",
    children: "Summary of Estimated Project Cost",
    inputType: "h4",
    inForm: true,
    wrapperClass: "col-md-12 mt-4",
    className: "heading2",
  },
  {
    category: "summaryOfProjectCost",
    children:
      "Please fill in the total cost. If project is covering more than one sector. Indicate separate project costs for separate sectors",
    inputType: "p",
    inForm: true,
    wrapperClass: "col-md-12",
  },
  {
    category: "summaryOfProjectCost",
    label: "Fund Currency",
    placeholder: "Select Currency of Fund",
    name: "fundsCurrencyId",
    id: "fundsCurrencyId",
    inputType: "async-dropdown",
    url: "/Currency",
    searchAttrib: "Search.value",
    labelAttribute: "name",
    valueAttribute: "id",
    onChangeMethod: "dropdown-in-table",
    inForm: true,
    isMulti: false,
  },
  {
    category: "summaryOfProjectCost",
    children: "Program Cost",
    inputType: "h4",
    inForm: true,
    wrapperClass: "col-md-12 mt-4",
    className: "heading2",
  },
  {
    category: "summaryOfProjectCost",
    label: "Amount In USD",
    placeholder: "Enter Amount In USD",
    name: "amountinUSD",
    inForm: true,
    wrapperClass: "col-md-4",
  },
  {
    category: "summaryOfProjectCost",
    label: "Equivalent PKR Amount",
    placeholder: "Enter Equivalent PKR amount",
    name: "amountInPKR",
    inForm: true,
    wrapperClass: "col-md-4",
    condition: {
      fieldName: "fundsCurrencyId",
      matchValue: "PKR",
      action: "hide",
      hideOnLabel: true,
    },
  },
  {
    category: "summaryOfProjectCost",
    label: "% Age to Total",
    placeholder: "Enter Age to Total",
    name: "totalPercentage",
    onChangeMethod: "text-in-table",
    wrapperClass: "col-md-4",
    inForm: true,
  },
  {
    category: "summaryOfProjectCost",
    label: "Remarks",
    placeholder: "Enter Remarks",
    name: "remarks",
    onChangeMethod: "text-in-table",
    wrapperClass: "col-md-8",
    inForm: true,
  },

  // work Plan
  {
    category: "workPlan",
    children: "Work Plan",
    inputType: "h4",
    inForm: true,
    wrapperClass: "col-md-12",
    className: "heading2",
  },
  {
    category: "workPlan",
    children: "Enter Revised Work Plan for the Project",
    inputType: "p",
    inForm: true,
    wrapperClass: "col-md-12",
  },
  {
    category: "workPlan",
    name: "workPlanTable",
    inputType: "tableInput",
    inForm: true,
    className: "w-100 table-overflow",
    wrapperClass: "col-12",
    header: [
      {
        label: "Work Type",
        placeholder: "Select Work Type",
        name: "workType",
        id: "workType",
        inputType: "async-dropdown",
        url: "/ERActivity/GetActivities",
        searchAttrib: "Search.value",
        labelAttribute: "name",
        valueAttribute: "id",
        onChangeMethod: "dropdown-in-table",
        className: "px-2",

        options: [
          { label: "test 1", value: "1" },
          { label: "test 2", value: "2" },
        ],
        inForm: true,
        isMulti: false,
      },
      {
        label: "Work Description",
        placeholder: "Select Work Description",
        name: "workdescription",
        id: "workdescription",
        inputType: "async-dropdown",
        url: "/ERActivity/GetActivities",
        searchAttrib: "Search.value",
        labelAttribute: "name",
        valueAttribute: "id",
        onChangeMethod: "dropdown-in-table",
        inForm: true,
        isMulti: false,
        className: "px-2",

        options: [
          {
            label: "test value 1",
            value: "1",
          },
          {
            label: "test value 2",
            value: "2",
          },
        ],
      },

      {
        label: "Start Date",
        placeholder: "Start Date",
        name: "startDate",
        inForm: true,
        wrapperClass: "col-md-4",
        inputType: "date",
      },
      {
        label: "End Date",
        placeholder: "End Date",
        name: "endDate",
        inForm: true,
        wrapperClass: "col-md-4",
        inputType: "date",
      },
      {
        label: "Responsibility",
        placeholder: "Enter Responsible Entity",
        name: "responsibility",
        onChangeMethod: "text-in-table",
        inForm: true,
      },
      {
        label: "Means of Verification",
        placeholder: "Select MoV",
        name: "meansOfVerification",
        id: "meansOfVerification",
        inputType: "async-dropdown",
        url: "/ERActivity/GetActivities",
        searchAttrib: "Search.value",
        labelAttribute: "name",
        valueAttribute: "id",
        onChangeMethod: "dropdown-in-table",
        className: "px-2",

        options: [
          { label: "test 1", value: "1" },
          { label: "test 2", value: "2" },
        ],
        inForm: true,
        isMulti: false,
        style: { zIndex: 999 },
      },
    ],
  },
  {
    category: "projectDetail",
    children: "Project Details",
    inputType: "h4",
    inForm: true,
    wrapperClass: "col-md-12",
    className: "heading2",
  },
  {
    category: "projectDetail",
    label: "Project Summary",
    placeholder: "Project Summary",
    name: "projectSummary",
    inputType: "textarea",
    inForm: true,
    wrapperClass: "col-md-6",
    style: {
      height: "120px",
      maxHeight: "140px",
    },
  },
  {
    category: "projectDetail",
    label: "Project Background",
    placeholder: "Project Background",
    name: "projectBackground",
    inputType: "textarea",
    inForm: true,
    wrapperClass: "col-md-6",
    style: {
      height: "120px",
      maxHeight: "140px",
    },
  },
  {
    category: "projectDetail",
    label: "Project Rational",
    placeholder: "Project Rational",
    name: "projectRational",
    inputType: "textarea",
    inForm: true,
    wrapperClass: "col-md-6",
    style: {
      height: "120px",
      maxHeight: "140px",
    },
  },
  {
    category: "projectDetail",
    label: "Implementation Strategy",
    placeholder: "Implementation Strategy",
    name: "implementationStrategy",
    inputType: "textarea",
    inForm: true,
    wrapperClass: "col-md-6",
    style: {
      height: "120px",
      maxHeight: "140px",
    },
  },
  {
    category: "projectDetail",
    label: "Project Goal",
    placeholder: "Project Goal",
    name: "projectGoal",
    inputType: "textarea",
    inForm: true,
    wrapperClass: "col-md-6",
    style: {
      height: "120px",
      maxHeight: "140px",
    },
  },
  {
    category: "projectDetail",
    label: "Outcomes & Output",
    placeholder: "Outcomes & Output",
    name: "outcomesAndOutput",
    inputType: "textarea",
    inForm: true,
    wrapperClass: "col-md-6",
    style: {
      height: "120px",
      maxHeight: "140px",
    },
  },
  {
    category: "projectDetail",
    label: "Coordination Mechanism",
    placeholder: "Coordination Mechanism",
    name: "coordinationMechanism",
    inputType: "textarea",
    inForm: true,
    wrapperClass: "col-md-6",
    style: {
      height: "120px",
      maxHeight: "140px",
    },
  },
  {
    category: "projectDetail",
    label: "Monitoring Strategy",
    placeholder: "Monitoring Strategy",
    name: "monitoringStrategy",
    inputType: "textarea",
    inForm: true,
    wrapperClass: "col-md-6",
    style: {
      height: "120px",
      maxHeight: "140px",
    },
  },

  // supporting documents
  {
    category: "supportingDocument",
    children: "Supporting documents List",
    inputType: "h4",
    inForm: true,
    wrapperClass: "col-md-12",
    className: "heading2",
  },
  {
    category: "supportingDocument",
    children: "The following documents are enclosed with the project proposal.",
    inputType: "p",
    inForm: true,
    wrapperClass: "col-md-12",
  },
  {
    category: "supportingDocument",
    label: "Covering letter from the Organization to Secretary RR&SD*",
    placeholder: "Upload Covering Letter",
    inputType: "multiFiles",
    name: "coveringLetter",
    id: "coveringLetter",
    onChangeMethod: "onMultiFileChange",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "supportingDocument",
    label: "Proposed Project Staff",
    placeholder: "Upload Proposed Project Staff (Excel)",
    inputType: "multiFiles",
    name: "proposedProjectStaff",
    id: "proposedProjectStaff",
    onChangeMethod: "onMultiFileChange",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "supportingDocument",
    label: "Documentary proof / evidence of the of source of funding",
    placeholder: "Upload Funding Proof",
    inputType: "multiFiles",
    name: "fundingProof",
    id: "fundingProof",
    onChangeMethod: "onMultiFileChange",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "supportingDocument",
    label: "Application vetted by the concerned ADC Relief or Line Department",
    placeholder: "Upload Application",
    inputType: "multiFiles",
    name: "applicationVetted",
    id: "applicationVetted",
    onChangeMethod: "onMultiFileChange",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "supportingDocument",
    label: "Detail budget estimate",
    placeholder: "Upload Application",
    inputType: "multiFiles",
    name: "detailBudgetEstimate",
    id: "detailBudgetEstimate",
    onChangeMethod: "onMultiFileChange",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "supportingDocument",
    label: "Agreement between donor and implementing organization",
    placeholder: "Upload Agreement",
    inputType: "multiFiles",
    name: "agreementDonorImplementingOrganization",
    id: "agreementDonorImplementingOrganization",
    onChangeMethod: "onMultiFileChange",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "supportingDocument",
    label: "Start Date of Agreement between Donor & Implementing Organization",
    placeholder: "Upload Agreement",
    inputType: "date",
    name: "startDateOfAgreement",
    id: "startDateOfAgreement",
    inForm: true,
    wrapperClass: "col-md-6",
  },
  {
    category: "supportingDocument",
    label: "End Date of Agreement between Donor & Implementing Organization",
    placeholder: "Upload Agreement",
    inputType: "date",
    name: "endDateOfAgreement",
    id: "endDateOfAgreement",
    inForm: true,
    wrapperClass: "col-md-6",
  },
];
